export default function parseDomain(email: string): string | undefined {
  return email.trim().split('@')[1]?.toLowerCase();
}
